import React from "react";


const CourseCardPrice = ({price}) => {

    return (
        <div class='flex flex-col'>
            <div className='price-wrapper'>
                <div className='price-content'>цена</div>
            </div>

            <div>
                <span className='text-[24px] dark:text-white font-semibold text-sub-title'>от {price.toLocaleString('ru-RU')} ₽</span>
                <span class='text-[24px] font-semibold text-light-gray'>/ мес</span>
            </div>
        </div>

    );
};

export default CourseCardPrice;